module.exports = __webpack_public_path__ + "static/media/roble_camel.712d9ba8.jpg";